const apiResponseStatus = {
    SUCCESS: "SUCCESS",
    OTP_TRIES_EXCEEDED: "OTP_TRIES_EXCEEDED",
};

export default Object.freeze(apiResponseStatus);